import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["data-modal-name"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  key: 0,
  class: "icon-modal-loader"
}


import usePromoModal from '@/composables/promoModalState';


export default /*#__PURE__*/_defineComponent({
  props: {
    modal: null
  },
  setup(__props: any) {



const { closeModal } = usePromoModal();

const isLoading = false;

return (_ctx: any,_cache: any) => {
  return (__props.modal)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-wrapper",
        "data-modal-name": __props.modal,
        "data-is-fiat": null
      }, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default"),
          isLoading
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "modal-close-modal",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(closeModal)()))
          })
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})